<template>
  <div class="rose-chart-container">
    <div class="wind-title">{{ $t('Monitoring1025.waveRoseDiagram') }}</div>
    <div id="windChart" class="wind-chart"></div>
    <div class="wind-cat-wrapper">
      <ul class="cat-list-container">
        <li class="cat-item" @click="changeShowCatIndex(0)">
          <span
            :class="{ box: true, 'box1-selected': this.selectedCats.indexOf(0) != -1, 'box-disable': this.canSelectedCats.indexOf(0) == -1 }"
          ></span>
          <span>0-1m</span>
        </li>
        <li class="cat-item" @click="changeShowCatIndex(1)">
          <span
            :class="{ box: true, 'box2-selected': this.selectedCats.indexOf(1) != -1, 'box-disable': this.canSelectedCats.indexOf(1) == -1 }"
          ></span>
          <span>1-2m</span>
        </li>
        <li class="cat-item" @click="changeShowCatIndex(2)">
          <span
            :class="{ box: true, 'box3-selected': this.selectedCats.indexOf(2) != -1, 'box-disable': this.canSelectedCats.indexOf(2) == -1 }"
          ></span>
          <span>2-3m</span>
        </li>
        <li class="cat-item" @click="changeShowCatIndex(3)">
          <span
            :class="{ box: true, 'box4-selected': this.selectedCats.indexOf(3) != -1, 'box-disable': this.canSelectedCats.indexOf(3) == -1 }"
          ></span>
          <span>3-4m</span>
        </li>
        <li class="cat-item" @click="changeShowCatIndex(4)">
          <span
            :class="{ box: true, 'box5-selected': this.selectedCats.indexOf(4) != -1, 'box-disable': this.canSelectedCats.indexOf(4) == -1 }"
          ></span>
          <span>4-5m</span>
        </li>
        <li class="cat-item" @click="changeShowCatIndex(5)">
          <span
            :class="{ box: true, 'box6-selected': this.selectedCats.indexOf(5) != -1, 'box-disable': this.canSelectedCats.indexOf(5) == -1 }"
          ></span>
          <span>5-6m</span>
        </li>
        <li class="cat-item" @click="changeShowCatIndex(6)">
          <span
            :class="{ box: true, 'box7-selected': this.selectedCats.indexOf(6) != -1, 'box-disable': this.canSelectedCats.indexOf(6) == -1 }"
          ></span>
          <span>6-7m</span>
        </li>
        <li class="cat-item" @click="changeShowCatIndex(7)">
          <span
            :class="{ box: true, 'box8-selected': this.selectedCats.indexOf(7) != -1, 'box-disable': this.canSelectedCats.indexOf(7) == -1 }"
          ></span>
          <span>7-8m</span>
        </li>
        <li class="cat-item" @click="changeShowCatIndex(8)">
          <span
            :class="{ box: true, 'box9-selected': this.selectedCats.indexOf(8) != -1, 'box-disable': this.canSelectedCats.indexOf(8) == -1 }"
          ></span>
          <span>9m+</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'

export default {
  props: {
    roseData: {
      type: Array
    }
  },
  data() {
    return {
      roseChart: null,
      selectedCats: [],
      canSelectedCats: []
    }
  },
  watch: {
    roseData(newVal) {
      if (newVal != null && Array.isArray(newVal)) {
        this.selectedCats = []
        // 数据
        for (let i = 0; i < 9; i++) {
          let item = newVal[i]
          const maxNumber = Math.max(...item)
          if (maxNumber > 0) {
            this.selectedCats.push(i)
            this.canSelectedCats.push(i)
          }
        }
        this.setRoseChartOptions()
      }
    }
  },
  methods: {
    initChart() {
      this.roseChart = echarts.init(document.getElementById('windChart'))
    },
    setRoseChartOptions() {
      let series = []
      for (let i = 0; i < this.selectedCats.length; i++) {
        let data = this.roseData[this.selectedCats[i]]
        series.push({
          type: 'bar',
          data: data,
          coordinateSystem: 'polar',
          name: this.levels[this.selectedCats[i]],
          stack: 'a',
          itemStyle: {
            normal: {
              color: this.roseColors[this.selectedCats[i]]
            }
          }
        })
      }
      // 配置玫瑰图
      let windOption = {
        angleAxis: {
          type: 'category',
          data: ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'],
          z: 0,
          boundaryGap: false,
          splitLine: {
            show: true,
            lineStyle: {
              color: 'white',
              type: 'dashed'
            }
          },
          axisLabel: {
            textStyle: {
              color: 'white',
              fontSize: 10,
              width: 2
            }
          },
          axisLine: {
            show: false
          }
        },
        radiusAxis: {
          center: ['50%', '50%'],
          splitLine: {
            show: true,
            lineStyle: {
              color: 'white',
              type: 'dashed'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: 'white',
              fontSize: 10
            }
          }
        },
        grid: {
          top: '3%',
          bottom: '3%',
          right: '3%',
          left: '3%'
        },
        polar: {},
        series: series,
        tooltip: {
          formatter: function(params) {
            return `
            ${params.name}: ${params.value}
            `
          }
        }
      }
      this.roseChart.setOption(windOption, true)
    },
    changeShowCatIndex(index) {
      console.log(index)
      if (this.canSelectedCats.indexOf(index) != -1) {
        let position = this.selectedCats.indexOf(index)
        if (position != -1) {
          this.selectedCats = this.selectedCats.filter(item => item != index)
        } else {
          this.selectedCats.push(index)
        }
        this.setRoseChartOptions()
      }
    }
  },
  created() {
    this.roseColors = [
      'rgba(0, 174, 255, 1)',
      'rgba(98, 217, 173, 1)',
      'rgba(121, 145, 195, 1)',
      'rgba(121, 211, 255, 1)',
      'rgba(255, 220, 76, 1)',
      'rgba(255, 151, 76, 1)',
      'rgba(230, 90, 86, 1)',
      'rgba(109, 97, 228, 1)',
      'rgba(117, 231, 101, 1)'
    ]
    this.levels = ['0-1m', '1-2m', '2-3m', '3-4m', '4-5m', '5-6m', '6-7m', '7-8m', '9m以上']
  },
  mounted() {
    this.initChart()
  },
  destroyed() {
    if (this.roseChart) {
      this.roseChart.dispose()
      this.roseChart = null
    }
  }
}
</script>

<style lang="scss" scoped>
.rose-chart-container {
  width: 300px;
  height: 350px;
  margin: 50px 46px 0 0;
  position: relative;

  .wind-title {
    position: absolute;
    width: 100%;
    height: 40px;
    text-align: center;
    font-size: 18px;
    color: #f9fafa;
    font-weight: bold;
    top: -25px;
  }

  .wind-chart {
    height: 290px;
  }

  .wind-cat-wrapper {
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .cat-list-container {
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 20px;
      flex-wrap: wrap;

      .cat-item {
        width: 70px;
        font-size: 13px;
        color: rgba(65, 70, 75, 1);
        font-weight: 300;
        margin: 2px 0;
        cursor: pointer;
        display: flex;
        align-items: center;

        .box {
          display: inline-block;
          width: 10px;
          height: 10px;
          margin-right: 4px;
          border: 1px solid #62a2cd;
          background-color: transparent;
        }

        .box1-selected {
          background: #00aeff;
        }

        .box2-selected {
          background: #62d9ad;
        }

        .box3-selected {
          background: #7991c3;
        }

        .box4-selected {
          background: #79d3ff;
        }

        .box5-selected {
          background: #ffdc4c;
        }

        .box6-selected {
          background: #ff974c;
        }

        .box7-selected {
          background: #e65a56;
        }

        .box8-selected {
          background: #6d61e4;
        }

        .box9-selected {
          background: rgba(117, 231, 101, 1);
        }

        .box-disable {
          border: 1px solid gray;
          background-color: transparent;
        }
      }
    }
  }
}
</style>
